export default __webpack_public_path__ + "static/media/bmw.64ddb05f.svg";